<div class="page-container">
  <div class="is-mt-label" *ngIf="amIMt">Vous êtes médecin traitant DMP de ce patient.</div>
  <div class="secret-mode-label" *ngIf="isSecretMode">Mode connexion secrète</div>
  <div class="bris-de-glace-label" *ngIf="isBrisDeGlace">BRIS DE GLACE</div>
  <div class="button-container">
    <!-- <frg-button *ngIf="!isBrisDeGlace" (activated)="handleTreatingPhysician()">
      <div *ngIf="dmp && !dmp.i_treatingPhysician" title="Se déclarer médecin traitant">Se déclarer médecin traitant</div>
      <div *ngIf="dmp && dmp.i_treatingPhysician" title="Se retirer médecin traitant">Se retirer médecin traitant</div>
    </frg-button> -->
    <frg-button (activated)="removeAccessAuthorization()" *ngIf="accessRight === dmpAccessRightTmpl.authorized && isBrisDeGlace">
      <div title="Se déconnecter du DMP">Se déconnecter du DMP</div>
    </frg-button>
    <frg-button (activated)="askChangeAuthorization()" *ngIf="accessRight !== dmpAccessRightTmpl.unknow && !isBrisDeGlace">
      <div title="Modifier droits d'accès">Modifier droits d'accès</div>
    </frg-button>
    <frg-button (activated)="openWebPsSpace()" *ngIf="accessRight === dmpAccessRightTmpl.authorized">
      <div title="Accéder à l’espace Web PS">Accéder à l’espace Web PS</div>
    </frg-button>
    <frg-button (activated)="addDocumentToDMP()" *ngIf="accessRight !== dmpAccessRightTmpl.unknow && autorisationAlimentation">
      <div title="Ajouter un document au DMP">Ajouter un document au DMP</div>
    </frg-button>
    <frg-button (activated)="getDocumentsSinceLastAccess()" *ngIf="accessRight === dmpAccessRightTmpl.authorized">
      <div title="Rechercher les documents ajoutés depuis ma dernière visite">Rechercher les derniers documents</div>
    </frg-button>
  </div>
  <div class="search-container" *ngIf="formGroup && (cpxAccess === connectionTypeTmpl.cps || cpxAccess === connectionTypeTmpl.cpf) && accessRight === dmpAccessRightTmpl.authorized && currentDmpStep === dmpSteps.dmpAccessRight">
    <div class="search-params">
      <form>
        <frg-form-input
          id="category"
          label="Catégorie"
          type="ngSelect"
          isMultiSelect="true"
          closeOnSelect="false"
          [selectValue]="dmpParamCategory"
          [formGroup]="formGroup"
          [control]="formGroup.get('category')"
        ></frg-form-input>

        <frg-form-input
          id="format"
          label="Format"
          type="ngSelect"
          isMultiSelect="true"
          closeOnSelect="false"
          [selectValue]="dmpParamFormat"
          [formGroup]="formGroup"
          [control]="formGroup.get('format')"
        ></frg-form-input>

        <frg-form-input
          id="status"
          label="Statut"
          type="ngSelect"
          closeOnSelect="false"
          [selectValue]="dmpParamStatus"
          [formGroup]="formGroup"
          [control]="formGroup.get('status')"
          isMultiSelect="true"
        ></frg-form-input>

        <frg-form-input
          id="visibility"
          label="Visibilité"
          type="ngSelect"
          closeOnSelect="false"
          [selectValue]="dmpParamVisibility"
          [formGroup]="formGroup"
          [control]="formGroup.get('visibility')"
        ></frg-form-input>

        <div class="date-selector-group">
          <frg-form-input
            id="dateStartMedicActsBottom"
            label="Date de début des actes médicaux (borne basse)"
            type="date"
            [formGroup]="formGroup"
            [control]="formGroup.get('dateStartMedicActsBottom')"
          ></frg-form-input>

          <frg-form-input
            id="dateEndMedicActsBottom"
            label="Date de fin des actes médicaux (borne basse)"
            type="date"
            [formGroup]="formGroup"
            [control]="formGroup.get('dateEndMedicActsBottom')"
          ></frg-form-input>
        </div>

        <div class="date-selector-group">
          <frg-form-input
            id="dateStartMedicActsTop"
            label="Date de début des actes médicaux (borne haute)"
            type="date"
            [formGroup]="formGroup"
            [control]="formGroup.get('dateStartMedicActsTop')"
          ></frg-form-input>

          <frg-form-input
            id="dateEndMedicActsTop"
            label="Date de fin des actes médicaux (borne haute)"
            type="date"
            [formGroup]="formGroup"
            [control]="formGroup.get('dateEndMedicActsTop')"
          ></frg-form-input>
        </div>

        <div class="date-selector-group">
          <frg-form-input
            id="dateStartDocumentCreation"
            label="Date de début de création du document"
            type="date"
            [formGroup]="formGroup"
            [control]="formGroup.get('dateStartDocumentCreation')"
          ></frg-form-input>

          <frg-form-input
            id="dateEndDocumentCreation"
            label="Date de fin de création du document"
            type="date"
            [formGroup]="formGroup"
            [control]="formGroup.get('dateEndDocumentCreation')"
          ></frg-form-input>
        </div>

        <div class="date-selector-group">
          <frg-form-input
            id="dateStartDocumentSubmission"
            label="Date de début de soumission du document"
            type="date"
            [formGroup]="formGroup"
            [control]="formGroup.get('dateStartDocumentSubmission')"
          ></frg-form-input>

          <frg-form-input
            id="dateEndDocumentSubmission"
            label="Date de fin de soumission du document"
            type="date"
            [formGroup]="formGroup"
            [control]="formGroup.get('dateEndDocumentSubmission')"
          ></frg-form-input>
        </div>
      </form>
      <div class="button-container">
        <frg-button (activated)="searchDocuments()">
          <div title="Rechercher des documents dans le DMP">Rechercher</div>
        </frg-button>
      </div>
    </div>

    <div class="search-result" *ngIf="documentsTable && documentsTable.objects && documentsTable.objects.length > 0">
      <div class="doc-from-patient-infos" *ngIf="resultHasDocFromPatient">
        Les documents dont les informations apparaîssent en vert sont des documents d'expression du patient ou déposés par le patient.
      </div>
      <frg-table
        [keysBody]="documentsTable"
        [keysColumn]="documentsTableColumnTable"
        [tableButton1]="'assets/icons/download.svg'"
        (onClick1)="downloadDocument($event)"
        [tableButton1Tooltip]="'Télécharger le document'"
        [tableButton2]="'assets/icons/trash.svg'"
        (onClick2)="deleteDocument($event)"
        [tableButton2Tooltip]="'Supprimer le document'"
        [tableButton3]="'assets/icons/edit.svg'"
        (onClick3)="openDocFormEdit($event)"
        [tableButton3Tooltip]="'Modifier le document'"
      ></frg-table>
    </div>
  </div>

  <!-- Affichage des documents dont le PS est responsable -->
  <div class="search-result my-docs" *ngIf="currentDmpStep === dmpSteps.myDocuments && (accessRight === dmpAccessRightTmpl.authorized || accessRight === dmpAccessRightTmpl.unauthorized || cardType && cardType.type === cardInfosTmpl.CPE) && myDocsTable && myDocsTable.objects && myDocsTable.objects.length > 0">
    <div class="table-label">Mes documents ajoutés au DMP</div>
    <frg-table
      [keysBody]="myDocsTable"
      [keysColumn]="myDocsTableColumnTable"
      [tableButton1]="'assets/icons/trash.svg'"
      (onClick1)="deleteDocFromUser($event)"
      [tableButton1Tooltip]="'Supprimer le document'"
      [tableButton2]="'assets/icons/edit.svg'"
      (onClick2)="openDocFormEdit($event)"
      [tableButton2Tooltip]="'Modifier le document'"
    ></frg-table>
  </div>
</div>
